/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  CheckSmartPayAsYouGoEligibilityParams,
  GetSmartPayAsYouGoExecutionDateParams,
  SmartPayAsYouGoEligibilityResponse,
  SmartPayAsYouGoExecutionDateResponse,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Retrieve So Pay As You Go Eligibility for an account
 */
export const checkSmartPayAsYouGoEligibility = (
  params: CheckSmartPayAsYouGoEligibilityParams,
  options?: SecondParameter<
    typeof backofficeRequest<SmartPayAsYouGoEligibilityResponse[]>
  >,
) => {
  return backofficeRequest<SmartPayAsYouGoEligibilityResponse[]>(
    { url: `/accounts/checkSpaygEligibility`, method: "GET", params },
    options,
  )
}
/**
 * @summary Calculate So Pay As You Go Execution date based in configured number of working days
 */
export const getSmartPayAsYouGoExecutionDate = (
  params: GetSmartPayAsYouGoExecutionDateParams,
  options?: SecondParameter<
    typeof backofficeRequest<SmartPayAsYouGoExecutionDateResponse>
  >,
) => {
  return backofficeRequest<SmartPayAsYouGoExecutionDateResponse>(
    { url: `/accounts/smartPayAsYouGo/executionDate`, method: "GET", params },
    options,
  )
}
export type CheckSmartPayAsYouGoEligibilityResult = NonNullable<
  Awaited<ReturnType<typeof checkSmartPayAsYouGoEligibility>>
>
export type GetSmartPayAsYouGoExecutionDateResult = NonNullable<
  Awaited<ReturnType<typeof getSmartPayAsYouGoExecutionDate>>
>
